import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
// import { Container, Row, Col, Alert, Tabs, Tab, Card, CardBody, Form, Label, Input, FormFeedback, Button } from 'react-bootstrap';



//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import withRouter from "components/Common/withRouter"

// API

// assets

// actions
import { resetProfileFlag } from "../../store/actions"

import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import "./user-profile.scss"
import { classnames } from "classnames"

const UserProfile = () => {
  //meta title
  document.title = "Profile | Pixwik "

  const dispatch = useDispatch()
  const userData = JSON.parse(localStorage.getItem("userData"))
  const [activeTab, setActiveTab] = useState("1")
  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }


  const selectProfileState = state => state.Profile
  const ProfileProperties = createSelector(selectProfileState, profile => ({
    error: profile.error,
    success: profile.success,
  }))

  const { error, success } = useSelector(ProfileProperties)

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        dispatch(resetProfileFlag())
      }, 3000)
    }
  }, [dispatch, success])



  return (
    <React.Fragment>
      <div className="page-content p-0">
        <Container fluid>
          <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <h4 className="card-title mb-4">Profile</h4>
              <Nav tabs className="nav-tabs-custom mb-3">
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => toggleTab("1")}
                  >
                    <i className="ri-user-line me-1"></i> Profile
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <Row>
                    <Col lg="12">
                      <Card>
                        <CardBody>
                          <div className="d-flex gap-3">
                            <div className="ms-3">
                              <span className="user-profile rounded-circle">
                                {userData?.userName?.charAt(0).toUpperCase()}
                              </span>
                            </div>
                            <div className="flex-grow-1 align-self-center">
                              <div className="text-muted">
                                <h5 className="userName ">
                                  {userData.userName}
                                </h5>
                                <p className="mb-1">{userData.email}</p>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserProfile)
